var chunkToChildrenMap = {
	"5385": [
		973,
		8406,
		297,
		1869,
		970,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};